import React, { useState,useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Form,
  Button,
  Col,
  Row,
} from 'react-bootstrap';
import { insert_new_channel } from '../../../../utils/crm_services';
import { loadCountriesData, buildCountrySelectOptions } from '../../../../utils/countries';
import Select from 'react-select';



function New_channel  ({user_id, permission, onSet, token }) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    
  const [countryOptions, setcountryOptions] = useState([]);
   
   const [channelName, setchannelName] = useState('');
  const [editableChannelName, setEditableChannelName] = useState(channelName);  
    const [country, setCountry] = useState('');
    
    const [description, setDescription] = useState('');
  
  
  
    
    const handleNameChange = (event) => {
      const newValue = event.target.value;
      setEditableChannelName(newValue);
  
  };

  const formatOptionLabel = ({ label, flagUrl }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {flagUrl && <img src={flagUrl} alt={`Flag of ${label}`} style={{ width: '20px', marginRight: '10px' }} />}
      <span>{label}</span>
    </div>
  );

  
     const createNewChannel =() =>{
            
              async function fetchcreateNew(name) {
    
                const channelList = await insert_new_channel(token,name, description, country,  0, 'new');
                if (channelList==="INVALID"){
                  navigate("/");
                
                }else{
                  navigate("/channel_panel?chid=" + channelList);
               }
              }
    
              fetchcreateNew(editableChannelName);
       
        }

        const getOptionByValue = (value) => {
          return countryOptions.find(option => option.value === value);
        };
   
         useEffect(() => {
                    loadCountriesData()
                      .then((data) => {
                        setcountryOptions(buildCountrySelectOptions(data));
                      })
                      .catch((error) => console.error('Error fetching countries:', error));
                  }, []);
        
    // ---------- UI ----------
    return (
         <div className="row align-items-start gy-3 flex-nowrap">
      <Col xs={12} md={12}>
        {/* Columna izquierda ------------------------------------------------- */}
        <Row className="align-items-start"> {/* Usamos Row para la distribución principal */}
            {/* Columna para Channel Name */}
            <Col xs={12} md={7}>
                
                <textarea
                    rows={2} // Esta propiedad ahora tendrá efecto
                    className="display-5 fw-bold mb-0 text-start opportunity-name-input form-control"
                    value={editableChannelName}
                    placeholder='Reseller name'
                    onChange={handleNameChange}
                ></textarea>
            </Col>

            {/* Columna para Country Select y Link Strategy */}
            <Col xs={12} md={5} className="d-flex flex-column justify-content-start"> {/* Usamos d-flex y flex-column */}
                <div className="mb-3"> {/* Margen inferior para separar el Select del botón */}
                   {/* Contenedor para el Badge/Botón Link Strategy */}
                    
                    <dt className="fw-normal text-muted lh-sm">
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={countryOptions}
                            isLoading={countryOptions.length === 0}
                            formatOptionLabel={formatOptionLabel}
                            onChange={(selectedOption) => {
                                setCountry(selectedOption.value);
                            }}
                            value={getOptionByValue(country)}
                            placeholder="Country..."
                            isSearchable
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    minWidth: 100,
                                    flex: 1,
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                })
                            }}
                        />
                    </dt>
                </div>

               
            </Col>

           
        </Row>

        <Row className="align-items-start">
              <Form.Control
                  as="textarea"
                  rows={4}
                  value={description}
                  placeholder="Description..."
                  onChange={(e) => {
                     
                      setDescription(e.target.value)
                  }}
                  />
        </Row>

         <div className="d-flex flex-wrap gap-2 justify-content-lg-end mt-auto mb-4">
                    {/* Conditionally render the Save Change button */}
                   
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={()=>{createNewChannel()}}
                        // Call the new save handler
                    >
                        Save Change
                    </Button>
                  
                    {/* You might also want a Cancel button here if the name is edited */}
                  
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => {
                            onSet(); // Reset to original name
                        }}
                    >
                        Cancel
                    </Button>
                   
                </div>
      </Col>
      </div>
    );
};

export default New_channel;
